import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_sales_contract_template_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fixed_asset_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  subscription_duration_day: fromDatatype.IntegerDatatypeInterface;
  subscription_duration_month: fromDatatype.IntegerDatatypeInterface;
  is_ekyc_required: boolean;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  ekyc_validity_period: fromDatatype.IntegerDatatypeInterface;
  gen_doc_template_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_sales_contract_template_hdr_RowClass
  implements bl_fi_sales_contract_template_hdr_RowInterface
{
  remarks: fromDatatype.VarcharDatatypeInterface;
  ekyc_validity_period: fromDatatype.IntegerDatatypeInterface;
  gen_doc_template_guid: fromDatatype.GuidDataFieldInterface;
  guid: fromDatatype.GuidDataFieldInterface;
  fixed_asset_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  subscription_duration_day: fromDatatype.IntegerDatatypeInterface;
  subscription_duration_month: fromDatatype.IntegerDatatypeInterface;
  is_ekyc_required: boolean;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
